"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PublicDatasService () {
        return PublicDatasService;
    },
    get sanitizeUrlPath () {
        return sanitizeUrlPath;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _utils = require("~/utils");
const _models = require("~/models");
const _catchError = require("~/helpers/catchError");
const _getAst = /*#__PURE__*/ _interop_require_default(require("~/helpers/getAst"));
const _PagedResponse = require("~/helpers/PagedResponse");
const _dataHelpers = require("~/helpers/dataHelpers");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
const _dbHelpers = require("~/helpers/dbHelpers");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _datasservice = require("~/services/datas.service");
const _attachmentsservice = require("~/services/attachments.service");
const _publicmetasservice = require("~/services/public-metas.service");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function sanitizeUrlPath(paths) {
    return paths.map((url)=>url.replace(/[/.?#]+/g, '_'));
}
let PublicDatasService = class PublicDatasService {
    async dataList(context, param) {
        const { sharedViewUuid, password, query = {} } = param;
        const view = await _models.View.getByUUID(context, sharedViewUuid);
        if (!view) _catchError.NcError.get(context).viewNotFound(sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID && view.type !== _nocodbsdk.ViewTypes.KANBAN && view.type !== _nocodbsdk.ViewTypes.GALLERY && view.type !== _nocodbsdk.ViewTypes.MAP && view.type !== _nocodbsdk.ViewTypes.CALENDAR) {
            _catchError.NcError.get(context).notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, password)) {
            return _catchError.NcError.get(context).invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const { ast, dependencyFields } = await (0, _getAst.default)(context, {
            model,
            query: {},
            view,
            includeRowColorColumns: query.include_row_color === 'true'
        });
        const listArgs = _extends({}, query, dependencyFields);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        let data = [];
        let count = 0;
        try {
            data = await (0, _utils.nocoExecute)(ast, await baseModel.list(listArgs), {}, listArgs);
            count = await baseModel.count(listArgs);
        } catch (e) {
            if (e instanceof _catchError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
            console.log(e);
            _catchError.NcError.get(context).internalServerError('Please check server log for more details');
        }
        return new _PagedResponse.PagedResponseImpl(data, _extends({}, param.query, {
            count
        }));
    }
    async dataCount(context, param) {
        const { sharedViewUuid, password } = param;
        const view = await _models.View.getByUUID(context, sharedViewUuid);
        if (!view) _catchError.NcError.get(context).viewNotFound(sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID && view.type !== _nocodbsdk.ViewTypes.KANBAN && view.type !== _nocodbsdk.ViewTypes.GALLERY && view.type !== _nocodbsdk.ViewTypes.MAP && view.type !== _nocodbsdk.ViewTypes.CALENDAR) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const countArgs = _extends({}, param.query, {
            throwErrorIfInvalidParams: true
        });
        try {
            countArgs.filterArr = JSON.parse(countArgs.filterArrJson);
        } catch (e) {}
        const count = await baseModel.count(countArgs);
        return {
            count
        };
    }
    async dataAggregate(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const listArgs = _extends({}, param.query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.aggregation = JSON.parse(listArgs.aggregation);
        } catch (e) {}
        return await baseModel.aggregate(listArgs, view);
    }
    // todo: Handle the error case where view doesnt belong to model
    async groupedDataList(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID && view.type !== _nocodbsdk.ViewTypes.KANBAN && view.type !== _nocodbsdk.ViewTypes.GALLERY) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        return await this.getGroupedDataList(context, {
            model,
            view,
            query: param.query,
            groupColumnId: param.groupColumnId
        });
    }
    async getGroupedDataList(context, param) {
        const { model, view, query = {}, groupColumnId } = param;
        const source = await _models.Source.get(context, param.model.source_id);
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const { ast } = await (0, _getAst.default)(context, {
            model,
            query: param.query,
            view,
            includeRowColorColumns: query.include_row_color === 'true'
        });
        const listArgs = _extends({}, query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        try {
            listArgs.options = JSON.parse(listArgs.optionsArrJson);
        } catch (e) {}
        let data = [];
        try {
            const groupedData = await baseModel.groupedList(_extends({}, listArgs, {
                groupColumnId
            }));
            data = await (0, _utils.nocoExecute)({
                key: 1,
                value: ast
            }, groupedData, {}, listArgs);
            const countArr = await baseModel.groupedListCount(_extends({}, listArgs, {
                groupColumnId
            }));
            data = data.map((item)=>{
                var _ref;
                var _countArr_find;
                // todo: use map to avoid loop
                const count = (_ref = (_countArr_find = countArr.find((countItem)=>countItem.key === item.key)) == null ? void 0 : _countArr_find.count) != null ? _ref : 0;
                item.value = new _PagedResponse.PagedResponseImpl(item.value, _extends({}, query, {
                    count: count
                }));
                return item;
            });
        } catch (e) {
            console.log(e);
            _catchError.NcError.internalServerError('Please check server log for more details');
        }
        return data;
    }
    async dataGroupByCount(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID) {
            _catchError.NcError.notFound('Not found');
        }
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        return await this.getDataGroupByCount(context, {
            model,
            view,
            query: param.query
        });
    }
    async dataGroupBy(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        return await this.getDataGroupBy(context, {
            model,
            view,
            query: param.query
        });
    }
    async getDataGroupByCount(context, param) {
        const { model, view, query = {} } = param;
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const listArgs = _extends({}, query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {
            listArgs.filterArr = (0, _nocodbsdk.ncIsArray)(listArgs == null ? void 0 : listArgs.filterArrJson) ? listArgs == null ? void 0 : listArgs.filterArrJson : null;
        }
        return await baseModel.groupByCount(listArgs);
    }
    async getDataGroupBy(context, param) {
        try {
            const { model, view, query = {} } = param;
            const base = await _models.Base.get(context, view.base_id);
            this.publicMetasService.checkViewBaseType(view, base);
            const source = await _models.Source.get(context, model.source_id);
            const baseModel = await _models.Model.getBaseModelSQL(context, {
                id: model.id,
                viewId: view == null ? void 0 : view.id,
                dbDriver: await _NcConnectionMgrv2.default.get(source),
                source
            });
            const listArgs = _extends({}, query);
            try {
                listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
            } catch (e) {
                listArgs.filterArr = (0, _nocodbsdk.ncIsArray)(listArgs == null ? void 0 : listArgs.filterArrJson) ? listArgs == null ? void 0 : listArgs.filterArrJson : null;
            }
            try {
                listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
            } catch (e) {
                listArgs.sortArr = (0, _nocodbsdk.ncIsArray)(listArgs == null ? void 0 : listArgs.sortArrJson) ? listArgs == null ? void 0 : listArgs.sortArrJson : null;
            }
            const data = await baseModel.groupBy(listArgs);
            const count = await baseModel.groupByCount(listArgs);
            return new _PagedResponse.PagedResponseImpl(data, _extends({}, query, {
                count
            }));
        } catch (e) {
            console.log(e);
            _catchError.NcError.internalServerError('Please check server log for more details');
        }
    }
    async dataInsert(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.FORM) _catchError.NcError.notFound();
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        const source = await _models.Source.get(context, model.source_id);
        if (source == null ? void 0 : source.is_data_readonly) {
            _catchError.NcError.sourceDataReadOnly(source.alias);
        }
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        await view.getViewWithInfo(context);
        await view.getColumns(context);
        await view.getModelWithInfo(context);
        await view.model.getColumns(context);
        const fields = view.model.columns = view.columns.filter((c)=>c.show && view.model.columnsById[c.fk_column_id]).reduce((o, c)=>{
            o[view.model.columnsById[c.fk_column_id].title] = new _models.Column(_extends({}, c, view.model.columnsById[c.fk_column_id]));
            return o;
        }, {});
        let body = param == null ? void 0 : param.body;
        if (typeof body === 'string') body = JSON.parse(body);
        const insertObject = Object.entries(body).reduce((obj, [key, val])=>{
            if (key in fields) {
                obj[key] = val;
            }
            return obj;
        }, {});
        const attachments = {};
        for (const file of param.files || []){
            // remove `_` prefix and `[]` suffix
            const fieldName = Buffer.from((file == null ? void 0 : file.fieldname) || '', 'binary').toString('utf-8').replace(/^_|\[\d*]$/g, '');
            if (fieldName in fields && fields[fieldName].uidt === _nocodbsdk.UITypes.Attachment) {
                attachments[fieldName] = attachments[fieldName] || [];
                attachments[fieldName].push(...await this.attachmentsService.upload({
                    files: [
                        file
                    ],
                    req: param.req
                }));
            }
        }
        // filter the uploadByUrl attachments
        const uploadByUrlAttachments = [];
        for (const [column, data] of Object.entries(insertObject)){
            if (fields[column].uidt === _nocodbsdk.UITypes.Attachment && Array.isArray(data)) {
                data.forEach((file, uploadIndex)=>{
                    if ((file == null ? void 0 : file.url) && !(file == null ? void 0 : file.file)) {
                        uploadByUrlAttachments.push(_extends({}, file, {
                            fieldName: column,
                            uploadIndex
                        }));
                    }
                });
            }
        }
        for (const file of uploadByUrlAttachments){
            attachments[file.fieldName] = attachments[file.fieldName] || [];
            attachments[file.fieldName].unshift(...await this.attachmentsService.uploadViaURL({
                urls: [
                    file.url
                ],
                req: param.req
            }));
        }
        for (const [column, data] of Object.entries(attachments)){
            insertObject[column] = JSON.stringify(data);
        }
        return await baseModel.nestedInsert(insertObject, param.req, null);
    }
    async relDataList(context, param) {
        var _param_query;
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.FORM && view.type !== _nocodbsdk.ViewTypes.GALLERY) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            _catchError.NcError.invalidSharedViewPassword();
        }
        const column = await _models.Column.get(context, {
            colId: param.columnId
        });
        const currentModel = await view.getModel(context);
        await currentModel.getColumns(context);
        const colOptions = await column.getColOptions(context);
        const model = await colOptions.getRelatedTable(context);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: colOptions.fk_target_view_id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const { ast, dependencyFields } = await (0, _getAst.default)(context, {
            query: param.query,
            model,
            extractOnlyPrimaries: true
        });
        const listArgs = dependencyFields;
        try {
            if (listArgs.filterArrJson) listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        if (view.type === _nocodbsdk.ViewTypes.FORM && (0, _nocodbsdk.ncIsArray)((_param_query = param.query) == null ? void 0 : _param_query.fields)) {
            param.query.fields.forEach(listArgs.fieldsSet.add, listArgs.fieldsSet);
            param.query.fields.forEach((f)=>{
                if (ast[f] === undefined) {
                    ast[f] = 1;
                }
            });
        }
        let data = [];
        let count = 0;
        try {
            var _column_meta;
            const customConditions = await (0, _dbHelpers.replaceDynamicFieldWithValue)(param.rowData || {}, null, currentModel.columns, baseModel.readByPk)((((_column_meta = column.meta) == null ? void 0 : _column_meta.enableConditions) ? await _models.Filter.rootFilterListByLink(context, {
                columnId: param.columnId
            }) : []) || []);
            data = data = await (0, _utils.nocoExecute)(ast, await baseModel.list(_extends({}, listArgs, {
                customConditions
            })), {}, listArgs);
            count = await baseModel.count(_extends({}, listArgs, {
                customConditions
            }));
        } catch (e) {
            console.log(e);
            _catchError.NcError.internalServerError('Please check server log for more details');
        }
        return new _PagedResponse.PagedResponseImpl(data, _extends({}, param.query, {
            count
        }));
    }
    async publicMmList(context, param) {
        var _this;
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID && view.type !== _nocodbsdk.ViewTypes.KANBAN && view.type !== _nocodbsdk.ViewTypes.GALLERY && view.type !== _nocodbsdk.ViewTypes.CALENDAR) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            _catchError.NcError.invalidSharedViewPassword();
        }
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnId, await view.getModel(context));
        if (column.fk_model_id !== view.fk_model_id) _catchError.NcError.badRequest("Column doesn't belongs to the model");
        const source = await _models.Source.get(context, view.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: view.fk_model_id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const key = `List`;
        const requestObj = {
            [key]: 1
        };
        const data = (_this = await (0, _utils.nocoExecute)(requestObj, {
            [key]: async (args)=>{
                return await baseModel.mmList({
                    colId: param.columnId,
                    parentId: param.rowId
                }, args);
            }
        }, {}, {
            nested: {
                [key]: param.query
            }
        })) == null ? void 0 : _this[key];
        const count = await baseModel.mmListCount({
            colId: param.columnId,
            parentId: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({}, param.query, {
            count
        }));
    }
    async publicHmList(context, param) {
        var _this;
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID && view.type !== _nocodbsdk.ViewTypes.KANBAN && view.type !== _nocodbsdk.ViewTypes.GALLERY && view.type !== _nocodbsdk.ViewTypes.CALENDAR) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            _catchError.NcError.invalidSharedViewPassword();
        }
        const column = await (0, _dataHelpers.getColumnByIdOrName)(context, param.columnId, await view.getModel(context));
        if (column.fk_model_id !== view.fk_model_id) _catchError.NcError.badRequest("Column doesn't belongs to the model");
        const source = await _models.Source.get(context, view.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: view.fk_model_id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const key = `List`;
        const requestObj = {
            [key]: 1
        };
        const data = (_this = await (0, _utils.nocoExecute)(requestObj, {
            [key]: async (args)=>{
                return await baseModel.hmList({
                    colId: param.columnId,
                    id: param.rowId
                }, args);
            }
        }, {}, {
            nested: {
                [key]: param.query
            }
        })) == null ? void 0 : _this[key];
        const count = await baseModel.hmListCount({
            colId: param.columnId,
            id: param.rowId
        }, param.query);
        return new _PagedResponse.PagedResponseImpl(data, _extends({}, param.query, {
            count
        }));
    }
    async dataRead(context, param) {
        const { sharedViewUuid, rowId, password, query = {} } = param;
        const view = await _models.View.getByUUID(context, sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID && view.type !== _nocodbsdk.ViewTypes.KANBAN && view.type !== _nocodbsdk.ViewTypes.GALLERY && view.type !== _nocodbsdk.ViewTypes.MAP && view.type !== _nocodbsdk.ViewTypes.CALENDAR) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const row = await baseModel.readByPk(rowId, false, query);
        if (!row) {
            _catchError.NcError.recordNotFound(param.rowId);
        }
        return row;
    }
    async bulkDataList(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        const listArgs = _extends({}, param.query);
        let bulkFilterList = param.body;
        try {
            bulkFilterList = JSON.parse(bulkFilterList);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        if (!(bulkFilterList == null ? void 0 : bulkFilterList.length)) {
            _catchError.NcError.badRequest('Invalid bulkFilterList');
        }
        const dataListResults = await bulkFilterList.reduce(async (accPromise, dF)=>{
            const acc = await accPromise;
            const result = await this.datasService.dataList(context, {
                query: _extends({}, dF),
                model,
                view
            });
            acc[dF.alias] = result;
            return acc;
        }, Promise.resolve({}));
        return dataListResults;
    }
    async bulkGroupBy(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source),
            source
        });
        const listArgs = _extends({}, param.query);
        let bulkFilterList = param.body;
        try {
            bulkFilterList = JSON.parse(bulkFilterList);
        } catch (e) {}
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        if (!(bulkFilterList == null ? void 0 : bulkFilterList.length)) {
            _catchError.NcError.badRequest('Invalid bulkFilterList');
        }
        const [data, count] = await Promise.all([
            baseModel.bulkGroupBy(listArgs, bulkFilterList, view),
            baseModel.bulkGroupByCount(listArgs, bulkFilterList, view)
        ]);
        bulkFilterList.forEach((dF)=>{
            // sqlite3 returns data as string. Hence needs to be converted to json object
            let parsedData = data[dF.alias];
            if (typeof parsedData === 'string') {
                parsedData = JSON.parse(parsedData);
            }
            let parsedCount = count[dF.alias];
            if (typeof parsedCount === 'string') {
                parsedCount = JSON.parse(parsedCount);
            }
            data[dF.alias] = new _PagedResponse.PagedResponseImpl(parsedData, _extends({}, dF, {
                count: parsedCount == null ? void 0 : parsedCount.count
            }));
        });
        return data;
    }
    async bulkAggregate(context, param) {
        const view = await _models.View.getByUUID(context, param.sharedViewUuid);
        if (!view) _catchError.NcError.viewNotFound(param.sharedViewUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID) {
            _catchError.NcError.notFound('Not found');
        }
        const base = await _models.Base.get(context, view.base_id);
        this.publicMetasService.checkViewBaseType(view, base);
        if (!await _models.View.verifyPassword(view, param.password)) {
            return _catchError.NcError.invalidSharedViewPassword();
        }
        const model = await _models.Model.getByIdOrName(context, {
            id: view == null ? void 0 : view.fk_model_id
        });
        let bulkFilterList = param.body;
        const listArgs = _extends({}, param.query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.aggregation = JSON.parse(listArgs.aggregation);
        } catch (e) {}
        try {
            bulkFilterList = JSON.parse(bulkFilterList);
        } catch (e) {}
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const data = await baseModel.bulkAggregate(listArgs, bulkFilterList, view);
        return data;
    }
    constructor(datasService, jobsService, attachmentsService, publicMetasService){
        this.datasService = datasService;
        this.jobsService = jobsService;
        this.attachmentsService = attachmentsService;
        this.publicMetasService = publicMetasService;
    }
};
PublicDatasService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(1, (0, _common.Inject)((0, _common.forwardRef)(()=>'JobsService'))),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _datasservice.DatasService === "undefined" ? Object : _datasservice.DatasService,
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _attachmentsservice.AttachmentsService === "undefined" ? Object : _attachmentsservice.AttachmentsService,
        typeof _publicmetasservice.PublicMetasService === "undefined" ? Object : _publicmetasservice.PublicMetasService
    ])
], PublicDatasService);
